import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { JsgSharedModule } from './libs/shared/shared.module';
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { SharedModule } from 'libs/shared/src/lib/shared.module';
import * as homeComponent from './home/home.component';
import { NgxsDispatchPluginModule } from '@ngxs-labs/dispatch-decorator';
import { NgxsSelectSnapshotModule } from '@ngxs-labs/select-snapshot';
import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
import { NgxsFormPluginModule } from '@ngxs/form-plugin';
import { NgxsRouterPluginModule } from '@ngxs/router-plugin';
import { NgxsModule, Store } from '@ngxs/store';

// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { ConfigState } from 'libs/shared/src/lib/state/config.state';
import { environment } from '../environments/environment';
import { Oops401Component } from './errors/401/oops401.component';
import { Oops404Component } from './errors/404/oops404.component';
import { Oops500Component } from './errors/500/oops500.component';
import { AppRoutingModule } from './app-routing.module';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { HelpState } from './help/state/help.state';
import { HelpAction } from './help/state/actions/help.action';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { APP_BASE_HREF, PlatformLocation } from '@angular/common';
export function getBaseHref(platformLocation: PlatformLocation): string {
  return platformLocation.getBaseHrefFromDOM();
}
@NgModule({
  declarations: [
    AppComponent,
    homeComponent.HomeComponent,
    // errors
    Oops401Component,
    Oops404Component,
    Oops500Component,
  ],
  imports: [
    BrowserModule,
    JsgSharedModule,
    SharedModule,
    NgxsModule.forRoot([ConfigState, HelpState], {
      developmentMode: !environment.production,
    }),
    NgxsDispatchPluginModule.forRoot(),
    NgxsFormPluginModule.forRoot(),
    NgxsSelectSnapshotModule.forRoot(),
    NgxsRouterPluginModule.forRoot(),
    NgxsReduxDevtoolsPluginModule.forRoot(),
    AppRoutingModule,
    FlexLayoutModule,
    MatExpansionModule,
    MatIconModule,
    MatListModule,
    MatSidenavModule,
    ScrollingModule,
  ],
  providers: [
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { appearance: 'outline' },
    },
    {
      provide: 'window',
      useValue: window,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (store: Store) => () => store.dispatch(new HelpAction.Init()),
      deps: [Store],
      multi: true,
    },
    {
      provide: APP_BASE_HREF,
      useFactory: getBaseHref,
      deps: [PlatformLocation],
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
